
import Api from "@/api/userService";
import BasicInfo from "@/model/BasicInfo";
import BasicInfoParameter from "@/model/BasicInfoParameter";
import BasicInfoResultBean from "@/model/BasicInfoResultBean";
import {
  getCarLocationStatus,
  getCarStatusType,
} from "@/utils/DataConversionUtils";
import { PropType, computed, defineComponent, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "BasicInfo",
  props: {
    vin: {
      type: String as PropType<string>,
      required: true,
      defualt: "",
    },
    mapName: {
      type: String as PropType<string>,
      required: true,
      defualt: "",
    },
    locationFail: {
      type: Boolean as PropType<boolean>,
      required: true,
      defualt: false,
    },
    floorName: {
      type: String as PropType<string>,
      required: true,
      defualt: "",
    },
  },
  setup(props, context) {
    const carVin = computed<string>(() => props.vin);
    const mapname = computed<string>(() => props.mapName);
    const mLocationFail = computed<boolean>(() => props.locationFail);

    const charging = ref("0");
    const store = useStore();
    let basicInterval: any | undefined;
    const parmObj = new Object() as BasicInfoParameter;
    parmObj.vin = carVin.value;

    const { t } = useI18n();

    const basicInfo = ref<BasicInfo>();
    const getBasicInfoF = () => {
      Api.getCarBasicInfo(parmObj).then((res: BasicInfoResultBean) => {
        console.log("车辆基本信息", res);
        basicInfo.value = res.result as BasicInfo;
        store.commit("carStatus", basicInfo.value.vehicle_status);
      });
    };

    const IsaVailable = () => {
      basicInterval && clearInterval(basicInterval);
      basicInterval = setInterval(() => {
        getBasicInfoF();
      }, 5000);
    };
    IsaVailable();

    onUnmounted(() => {
      clearInterval(basicInterval);
    });

    return {
      basicInfo,
      getCarStatusType,
      charging,
      mapname,
      getCarLocationStatus,
      mLocationFail,
      t,
    };
  },
});
